module.exports = __webpack_public_path__ + "static/media/home.6949869b.gif";